import StickySidebar from 'sticky-sidebar'

const GouvernanceSticky = (target) => {
  const headerHeight = document.querySelector('.main-header').clientHeight

  const mediaQueryList = window.matchMedia('(min-width: 1024px)')

  const sidebars = {}

  const checkViewport = () => {
    for (const i in sidebars) {
      if (mediaQueryList.matches) {
        initGouvernanceSticky(i)
      } else {
        sidebars[i].destroy()
      }
    }
  }

  const initGouvernanceSticky = (i) => {
    sidebars[i] = new StickySidebar(`.js-sticky__sidebar-${i}`, {
      containerSelector: '.sticky__wrapper',
      innerWrapperSelector: '.sticky__sidebar__inner',
      topSpacing: headerHeight + 160,
      bottomSpacing: 88,
    });
  };

  $('body').find(target)
    .each(i => {
      initGouvernanceSticky(i);
    });

  mediaQueryList.addListener(() => checkViewport());
  checkViewport()
}

export default GouvernanceSticky;



// WEBPACK FOOTER //
// ./scripts/components/GouvernanceSticky.js